import type { PerspectiveId } from "@/lib/perspectives";

export interface ChatContextPack {
  title: string;
  subtitle: string;
  suggestions: string[];
}

// Per-lens starter framing for the perspective hero's "Kysy agentilta" CTA (one chat shell,
// many context packs). Only the header + starter suggestions change per
// lens; the session, backend, and shell are identical to every other chat entry point. Titles
// spell out "· Kysy agentilta" rather than "<Lens>assistentti" so this never reads like the
// dedicated, heavier Konfigurointiassistentti drawer.
export const CHAT_CONTEXT_PACKS: Record<PerspectiveId, ChatContextPack> = {
  "savings-potential": {
    title: "Strategia · Kysy agentilta",
    subtitle: "Suunta, rajat ja säästöpotentiaali",
    suggestions: [
      "Mikä on säästöpotentiaali?",
      "Ovatko rajat ylittyneet?",
      "Näytä ehdotetut strategiat",
    ],
  },
  "energy-efficiency": {
    title: "Optimointi · Kysy agentilta",
    subtitle: "Reseptit ja autonominen silmukka",
    suggestions: [
      "Mikä resepti on aktiivinen?",
      "Näytä ennuste vs. toteuma",
      "Onko silmukka poikennut rajoista?",
    ],
  },
  "indoor-conditions": {
    title: "Sisäilmaolosuhteet · Kysy agentilta",
    subtitle: "Vyöhykkeiden olosuhteet, elävä tila ja havainnot",
    suggestions: [
      "Miten vyöhykkeiden olosuhteet voivat juuri nyt?",
      "Mitkä vyöhykkeet vaativat toimia?",
      "Näytä vyöhykekohtaiset havainnot",
    ],
  },
  "equipment-performance": {
    title: "Analyysi · Kysy agentilta",
    subtitle: "Havainnot ja trendit",
    suggestions: [
      "Mitkä havainnot vaativat toimia?",
      "Näytä viikon trendit",
      "Mikä muuttui viime tickissä?",
    ],
  },
  "data-quality": {
    title: "Datan laatu · Kysy agentilta",
    subtitle: "Signaalit, tuoreus ja datan luotettavuus",
    suggestions: [
      "Mikä on kiinteistön tila?",
      "Näytä avoimet havainnot",
      "Mitä dataa puuttuu?",
    ],
  },
  configuration: {
    title: "Konfiguraatio · Kysy agentilta",
    subtitle: "Rakenne, signaalit ja kyvykkyydet",
    suggestions: [
      "Mitä konfiguraatiosta puuttuu?",
      "Mitkä kyvykkyydet ovat aktiivisia?",
      "Näytä signaalien kattavuus",
    ],
  },
};
